import { TableColumn } from "./dataInterface";

export const serviceTableColumn: TableColumn = {
  title: "サービスプラン一覧",
  detail: true,
  detailTitle: "サービスプラン詳細",
  detailColumn: "詳細",
  detailKey: ["id", "payment_method_id"],
  editAuth: ["マスターアカウント", "スタッフアカウント"],
  addTitle: "サービスプラン登録",
  tableFunction: [
    {
      name: "取扱い停止・再開",
      width: "120px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
  ],
  postCSVTitle: "サービスプランCSV取込",
  dataColumn: [
    {
      key: "high_rank_company_name",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "high_rank_company",
      detail: true,
      edit: false,
      editType: null,
      editId: "high_rank_company_id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_id",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "high_rank_company",
      addMessage: "",
    },
    {
      key: "product_name",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: true,
      edit: false,
      editType: null,
      editId: "product_id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "product_id",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "product",
      addMessage: "",
    },
    {
      key: "service_name",
      name: "サービス名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: true,
      editType: "text",
      editId: "id",
      add: true,
      addType: "text",
      addMessage: "",
    },
    {
      key: "no_entry_flg",
      name: "取扱い",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "50px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      detail: true,
      edit: false,
      editType: null,
      editId: "id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "service_type",
      name: "サービス種類",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "200px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "price_type",
      name: "単価区分",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "payment_method",
      name: "支払方法",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "payment_method_id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "staff_account_name",
      name: "スタッフアカウント",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "staff_account_id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "staff_account_id",
      name: "スタッフアカウント",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "staff_account_id",
      add: true,
      addType: "staff",
      addMessage: "",
    },
    {
      key: "payment_period",
      name: "支払い開始時期",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "entry_sale_company_name",
      name: "エントリーパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "payment_sale_company_name",
      name: "振込先パートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_company_name",
      name: "トスアップパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sns_send_flg",
      name: "チャットアプリ連携",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: true,
      editType: "list",
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "deposit_start_date",
      name: "条件適応期間",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "date",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
  ],
  subTable: [
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "入金単価一覧",
      subTableColumnLength: "deposit_length",
      subTableColumnNameWidth: "85px",
      detailKey: ["id", "payment_method_id"],
      subTableDetail: true,
      subTableDetailTitle: "上位店入金単価詳細",
      subTableAdd: true,
      subTableAddTitle: "入金単価追加",
      subTableAddTitleWidth: "85px",
      subTableEdit: true,
      subTableEditTitle: "上位店入金単価編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "high_rank_company_name",
          name: "上位店名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "high_rank_company_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "product_name",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "product_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "service_id",
          name: "サービス名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "service_id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "service_name",
          name: "サービス名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "service_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "service_type",
          name: "サービス種類",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "service_id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "price_type",
          name: "単価区分",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "service_id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "payment_method_id",
          name: "支払方法",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "payment_method_id",
          add: true,
          addType: "tableSubId",
          addMessage: "",
        },
        {
          key: "payment_method",
          name: "支払方法",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "payment_method_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "deposit_start_date",
          name: "条件適応期間 - 開始",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "date",
          editId: "service_high_rank_company_config_id",
          add: true,
          addType: "date",
          addMessage: "",
        },
        {
          key: "trading_type",
          name: "取引種類",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
        {
          key: "back_payment_time",
          name: "戻入対象期間",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "list",
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "取引種類が戻入の場合、戻入対象期間を選択してください。",
        },
        {
          key: "deposit_value",
          name: "上位店入金単価",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "パートナー一覧",
      subTableColumnLength: "entry_length",
      detailKey: ["id", "entry_sale_company_table_id", "payment_method_id"],
      subTableColumnNameWidth: "100px",
      subTableDetail: true,
      subTableDetailTitle: "パートナー支払単価詳細",
      subTableAdd: true,
      subTableAddTitle: "パートナー追加",
      subTableAddTitleWidth: "100px",
      subTableEdit: true,
      subTableEditTitle: "パートナー支払単価編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "high_rank_company_name",
          name: "上位店名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "high_rank_company_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "product_name",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "product_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "service_id",
          name: "サービス名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "service_id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "service_name",
          name: "サービス名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "service_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "payment_method_id",
          name: "支払方法",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "payment_method_id",
          add: true,
          addType: "tableSubId",
          addMessage: "",
        },
        {
          key: "payment_method",
          name: "支払方法",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "payment_method_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "entry_sale_company_id",
          name: "エントリーパートナー",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "entry_sale_company_table_id",
          add: true,
          addType: "company",
          addMessage: "",
        },
        {
          key: "entry_sale_company_name",
          name: "エントリーパートナー",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "entry_sale_company_table_id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "payment_start_date",
          name: "条件適応期間 - 開始",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "date",
          editId: "entry_sale_company_table_id",
          add: true,
          addType: "date",
          addMessage: "",
        },
        {
          key: "payment_end_date",
          name: "条件適応期間 - 終了",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "date",
          editId: "entry_sale_company_table_id",
          add: true,
          addType: "date",
          addMessage: "",
        },
        {
          key: "payment_start_end_date",
          name: "条件適応期間",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "entry_sale_company_table_id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "payment_sale_company_id",
          name: "振込先パートナー",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "company",
          addMessage: "",
        },
        {
          key: "payment_sale_company_name",
          name: "振込先パートナー",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "toss_up_company_name",
          name: "トスアップパートナー",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "trading_type",
          name: "取引種類",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
        {
          key: "unique_payment_name",
          name: "独自単価名",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "取引種類が独自単価の場合、明細に表示する独自単価名を記入して下さい。例：アポ減額",
        },
        {
          key: "service_toss_up_company_id",
          name: "トスアップパートナー",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "company",
          addMessage:
            "取引種類が独自単価の場合、必要に応じトスアップパートナーを指定してください。",
        },
        {
          key: "back_payment_time",
          name: "戻入対象期間",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "list",
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "取引種類が戻入の場合、戻入対象期間を選択してください。",
        },
        {
          key: "payment_value",
          name: "パートナー支払単価",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
        {
          key: "operation_value",
          name: "業務管理手数料",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "「振込金額」は「支払単価 - 各手数料」で計算されます。手数料には＋の値を入力してください。",
        },
        {
          key: "office_value",
          name: "事務手数料",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "「振込金額」は「支払単価 - 各手数料」で計算されます。手数料には＋の値を入力してください。",
        },
        {
          key: "partner_transfer",
          name: "振込金額",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "customer_list_id_flg",
          name: "リストID",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
      ],
      subTable: [
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          mainTableDetail: false,
          mainTableDetailColumn: "",
          subTableColumnName: "リストID一覧",
          subTableColumnLength: "customer_list_id_length",
          subTableColumnNameWidth: "85px",
          detailKey: ["id"],
          subTableDetail: false,
          subTableDetailTitle: "リストID詳細",
          subTableAdd: true,
          subTableAddTitle: "リストID追加",
          subTableAddTitleWidth: "85px",
          subTableEdit: false,
          subTableEditTitle: "リストID編集",
          subTableEditDirect: true,
          subTableEditDirectKey: "customer_list_id",
          subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
          tableFunction: [],
          subDataColumn: [
            {
              key: "payment_sale_company_table_id",
              name: "パートナー支払単価 テーブルID",
              table: false,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "payment_sale_company_table_id",
              add: true,
              addType: "tableId",
              addMessage: "",
            },
            {
              key: "customer_list_id",
              name: "リストID",
              table: true,
              tableValue: "text",
              detail: true,
              edit: true,
              editType: "text",
              editId: "id",
              add: true,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
      ],
    },
  ],
};
